import { Component } from 'vue-property-decorator'

Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate'
])



// WEBPACK FOOTER //
// ./src/common/registerHooks.js